import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { hide } from 'store/modules/modal';

// https://github.com/mikevercoelen/scalable-react-redux-modals/blob/master/src/components/Modal.js
export const ConfirmDialog = ({ opened, message, dispatch, id, handleYes }) => {
  return (
    <div>
      <Dialog open={opened} onClose={() => dispatch(hide())}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(hide());
            }}
            color="secondary"
            autoFocus
          >
            NO
          </Button>
          <Button
            onClick={() => {
              handleYes(id);
              dispatch(hide());
            }}
            color="primary"
          >
            YES
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    opened: state.modal.opened,
    message: ownProps.message,
  };
};

export default connect(mapStateToProps)(ConfirmDialog);
